import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { DragOverlayCellProps } from './DragOverlayCell.props';

export const DragOverlayCell: React.FC<DragOverlayCellProps> = ({ label }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        fontSize: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        fontWeight: 600,
        color: theme.palette.v4.accent,
        bgcolor: theme.palette.v4.tableEven,
        border: `1px solid ${theme.palette.v4.border}`,
        borderRadius: 1,
        px: 1.5,
        py: 0.75,
        whiteSpace: 'nowrap',
        boxShadow: theme.shadows[6],
        cursor: 'grabbing',
      }}
    >
      {label}
    </Box>
  );
};
